import { render, staticRenderFns } from "./aboutUsNew.vue?vue&type=template&id=aab65864&scoped=true"
import script from "./aboutUsNew.vue?vue&type=script&lang=js"
export * from "./aboutUsNew.vue?vue&type=script&lang=js"
import style0 from "./aboutUsNew.vue?vue&type=style&index=0&id=aab65864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab65864",
  null
  
)

export default component.exports